import React from 'react';
import { Button } from 'primereact/button';

const ReusableDeleteDialog = ({
  visible,
  onHide,
  onDelete,
  fields = [],
  formData = {},
  setFormData,
  loading = false,
  title = "Confirm Deletion",
  description = "Are you sure you want to delete this item? This action cannot be undone.",
  deleteLabel = "Delete",
  className = ""
}) => {
  const handleChange = (e, field) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onDelete(e);
  };

  return (
    visible && (
      <div className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 ${className}`}>
        <div className="bg-white rounded-xl shadow-2xl p-0 max-w-md w-full relative overflow-hidden">
          {/* Red Header */}
          <div className="bg-red-600 px-6 py-4 flex items-center justify-between">
            <h2 className="text-xl font-bold text-white">{title}</h2>
            <button className="text-white text-2xl leading-none" onClick={onHide}>&times;</button>
          </div>
          <form onSubmit={handleSubmit} className="p-6">
            <p className="text-gray-700 mb-4">{description}</p>
            {fields && fields.length > 0 && fields.map((field, index) => (
              <div key={`field-${field.name}-${index}`}>{field.visible !== false && (
                <div className="mb-6">
                  <label htmlFor={field.name} className="block text-sm font-medium text-gray-700 mb-2 tracking-wide">
                    {field.label}
                  </label>
                  <input
                    id={field.name}
                    name={field.name}
                    type={field.type === 'text' ? 'text' : field.type}
                    value={formData[field.name] || ''}
                    onChange={e => handleChange(e, field)}
                    className="w-full p-3.5 rounded-xl border border-gray-200 bg-white shadow-sm focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-all text-base placeholder-gray-400 outline-none hover:border-gray-300"
                    placeholder={field.placeholder || `Enter ${field.label.toLowerCase()}`}
                    required={field.required}
                  />
                  {field.helpText && (
                    <small className="text-gray-500 mt-1 block">{field.helpText}</small>
                  )}
                </div>
              )}</div>
            ))}
            <div className="flex justify-end gap-4 border-t border-gray-100 pt-8 mt-8">
              <Button
                label="Cancel"
                icon="pi pi-times"
                onClick={onHide}
                className="!bg-white !text-gray-600 !border !border-gray-300 !rounded-xl hover:!bg-gray-50 hover:!text-red-600 focus:!ring-2 focus:!ring-red-500 px-6 py-3 text-sm font-medium transition-all shadow-sm"
                type="button"
              />
              <Button
                label={deleteLabel}
                icon="pi pi-trash"
                type="submit"
                loading={loading}
                className="!bg-red-600 !text-white !rounded-xl !border-0 hover:!bg-red-700 focus:!ring-2 focus:!ring-red-500 px-8 py-3 text-sm font-medium shadow-md transition-all"
              />
            </div>
          </form>
        </div>
      </div>
    )
  );
};

export default ReusableDeleteDialog; 